module.exports = __webpack_public_path__ + "static/TeamLogo-61a2ea9678663498aee3e1187ac5a626.svg";